import React from 'react'

const RecipeDetailPage = () => {
  return (
    <div>RecipeDetailPage</div>
  )
}

export default RecipeDetailPage